/* jshint undef: true, unused: true */
/* globals globals */

var graphQLWrapper = require('../../../../js_functions/graphql/graphql-wrapper'),
    gqlStringifier = require('../../../../js_functions/graphql/graphql-js-stringifier'),
    drugSearchQueryGQL = require('raw-loader!./drug-search.graphql'),
    getDrugAnswersGQL = require('raw-loader!./drug-answers.graphql'),
    saveDrugMutationGQL = require('raw-loader!./drug-mutation.graphql'),
    deleteDrugMutationGQL = require('raw-loader!./drug-delete.graphql');

function medicationsGraphqlService(MedsDisplayStructure) {
  var // Variables
      optionalPairedFields = null,
      // Functions
      getDrugAnswers,
      getOptionalPairedFields,
      getDrugSearchQueryGQL,
      getDrugSearchResults,
      drugInputMutationMapping,
      submitMedication,
      deleteMedication,
      // Class objects
      structure = new MedsDisplayStructure();


  getDrugAnswers = function(recordUuid) {
    var modifiedDrugAnswersGQL = getDrugAnswersGQL
      .replace('$recordId', recordUuid)
      .replace(/\$optionalPairedFields/g, getOptionalPairedFields());

    return graphQLWrapper().ajaxCall(modifiedDrugAnswersGQL);
  };


  getOptionalPairedFields = function() {
    if (!optionalPairedFields) {
      optionalPairedFields = [];

      Object.keys(structure).map(function (key) {

        var item = structure[key];
        var isOptional = item.optional !== false;

        if (isOptional && item.globalSwitch && globals[item.globalSwitch] === true) {
          if (item.gqlField) {
            optionalPairedFields.push(item.gqlField);
          } else {
            optionalPairedFields.push(key);
          }
        }
      });

    }
    return optionalPairedFields;
  };

  getDrugSearchQueryGQL = function(searchTerm) {
    return drugSearchQueryGQL.replace('$searchTerm', searchTerm);
  };

  getDrugSearchResults = function(searchTerm) {

    var searchQuery = getDrugSearchQueryGQL(searchTerm);

    return new Promise((resolve, reject) => {
      graphQLWrapper()
        .ajaxCall(searchQuery)
        .then(function (data) {
          const resultsObject = data.data.RequestListOfDrugs;
          const medicationUniq = {};
          resultsObject.forEach(function (drug) {
            medicationUniq[drug.id] = drug;
          });

          resolve(medicationUniq);
        })
        .catch(reject);
    });
  };

  drugInputMutationMapping = function(values, prefix) {
    const mappedFields = {
      drugId             : values[prefix + 'DrugId'],
      route              : values[prefix + 'AdministrationRoute'],
      quantity           : values[prefix + 'AdministrationDosageValue'],
      unit               : values[prefix + 'AdministrationDosageUnit'],
      form               : values[prefix + 'FormAdministered']
    };

    const optionalPairedFields = getOptionalPairedFields();
    optionalPairedFields.forEach(function(field) {
      mappedFields[field] = values[prefix + field.charAt(0).toUpperCase() + field.slice(1)];
    });

    return mappedFields;
  };

  submitMedication = function (uid, values, answerUuid, recordUuid, successCallback) {
    const mutation = Object.entries({
      id: answerUuid,
      recordId: recordUuid,
      recordType: 'incident',
      administeredDrug: drugInputMutationMapping(values, 'administered'),
      correctDrug: drugInputMutationMapping(values, 'intended'),
      stageOfError: values.stageErrorOccurred,
      typeOfError: values.typeOfError,
      notes: values.notes,
      otherImportantFactors: values.importantFactors,
      adverseDrugReaction: {
        id: values.adrId,
        reactionStartDateAst: values.adrDateReactionStarted,
        reactionStopDateAst: values.adrDateReactionStopped,
        frequencyOfWrongMedication: values.frequencyWrong,
        drugReactionManifestation: values.drugReaction,
        errorDetectedBy: values.errorDetectedBy,
        errorCommittedBy: values.errorCommittedBy,
        appearedWhenReadministered: values.didDrugReactionReappear,
        organSystemFields: values.adrOrganSystem,
        naranjoTotalScore: values.naranjoTotalScore * 1,
        actionTaken: values.adrActionTaken,
      },
      dateFirstUsed: values.dateFirstUsed,
      dateLastUsed: values.dateLastUsed,
      reportedToManufacturer: values.reportedToManufacturer,
      dateReportedToManufacturer: values.dateReportedToManufacturer,
      manufacturerRef: values.manufacturerRef,
      isStillAdministered: values.isStillAdministered,
      frequency: values.frequency,
      productExpiryDate: values.productExpiryDate,
      actionTaken: values.actionTaken,
      adrLessened: values.adrLessened,
      adrReappeared: values.adrReappeared,
    })
      .filter(isEntryTruthy)
      .reduce(assignObjectEntry, {});

    function isEntryTruthy(entry) {
      return entry[1];
    }

    function assignObjectEntry(mtn, entry) {
      if (entry[0] === 'adverseDrugReaction') {
        mtn[entry[0]] = Object.entries(entry[1])
          .filter(isEntryTruthy)
          .reduce(assignObjectEntry, {});
      } else {
        mtn[entry[0]] = entry[1];
      }
      return mtn;
    }

    return new Promise((resolve, reject) => {
      graphQLWrapper()
        .ajaxCall(saveDrugMutationGQL.replace('$mutation', gqlStringifier([mutation])))
        .then(function (data) {
          var params = {
            uid    : uid,
            values : values,
            dataViewRecordIndex : values.dataViewRecordIndex
          };
          if (data.data.SaveListOfDrugAnswers) {
            const callback = () => successCallback(data, params);
            resolve(callback);
          } else {
            reject(graphQLWrapper().getReadableErrors(data.errors));
          }
        },
        function(error){
          reject(error);
        });
    });
  };

  deleteMedication = function (params, successCallback, errorCallback) {
    return graphQLWrapper()
      .ajaxCall(deleteDrugMutationGQL.replace('$answersId', params.answersId))
      .then(function (data) {
        params.data = data;
        successCallback(params);
      },
      function(response) {
        params.errors = response.errors || response;
        errorCallback(params);
      });
  };

  return {
    getDrugAnswers           : getDrugAnswers,
    getDrugSearchResults     : getDrugSearchResults,
    drugInputMutationMapping : drugInputMutationMapping,
    submitMedication         : submitMedication,
    deleteMedication         : deleteMedication
  };

}


module.exports = medicationsGraphqlService;
